import * as Scenes from "./scenes";
import { createButton, createDiv, createTextInput } from "./elements";
import { PCG } from "./pcg";
import { Card, Deck } from "./cards";


async function mainMenuScene(sceneContainer: HTMLDivElement)
{
    sceneContainer.appendChild(createButton(null, `Create Deck`, async () => {
        const deck: Deck = {
            name: "Deck",
            cards: {},
        };
        Scenes.setScene(deckEditorScene, deck);
    }));

    sceneContainer.appendChild(createButton(null, `Load Saved Deck`, async () => {
        const deck: Deck = JSON.parse(localStorage.getItem("deck"));
        if (deck !== null) {
            Scenes.setScene(handScene, deck);
        }
    }));
}


async function deckEditorScene(sceneContainer: HTMLDivElement, deck: Deck)
{
    function renderCard(card: Card) {
        const cardElement = sceneContainer.appendChild(createDiv("card"));
        cardElement.appendChild(createTextInput(null, card, "text"));
        cardElement.appendChild(createButton(null, "Delete Card", async () => {
            delete deck.cards[card.id];
            cardElement.remove();
        }));
    }

    const buttonRow = sceneContainer.appendChild(createDiv("row"));

    buttonRow.appendChild(createButton(null, "Add Card", async () => {
        const card: Card = {
            id: crypto.randomUUID(),
            text: "Card",
        };
        deck.cards[card.id] = card;
        renderCard(card);
    }));

    buttonRow.appendChild(createButton(null, "Cancel", async () => {
        Scenes.setScene(mainMenuScene);
    }));

    buttonRow.appendChild(createButton(null, "Finish Deck", async () => {
        localStorage.setItem("deck", JSON.stringify(deck));
        Scenes.setScene(handScene, deck);
    }));

    for (const card of Object.values(deck.cards)) {
        renderCard(card);
    }
}


async function handScene(sceneContainer: HTMLDivElement, deck: Deck)
{
    const hand: {[id: string]: Card} = {};
    const workingDeck = [];
    const discardPile: Card[] = [];
    const cardElements: {[id: string]: HTMLDivElement} = {};

    const buttonRow = sceneContainer.appendChild(createDiv("row"));
    const handContainer = sceneContainer.appendChild(createDiv("hand cards"));
    const infoContainer = sceneContainer.appendChild(createDiv("info"));
    const deckIndicator = infoContainer.appendChild(createDiv("indicator", "Deck: 0"));
    infoContainer.appendChild(createDiv(null, "/"));
    const discardIndicator = infoContainer.appendChild(createDiv("indicator", "Discard: 0"));
    const deckContainer = sceneContainer.appendChild(createDiv("hidden deck cards"));
    const discardContainer = sceneContainer.appendChild(createDiv("hidden discard cards"));

    deckIndicator.addEventListener("click", () => {
        discardContainer.classList.add("hidden");
        deckContainer.classList.toggle("hidden");
    });

    discardIndicator.addEventListener("click", () => {
        deckContainer.classList.add("hidden");
        discardContainer.classList.toggle("hidden");
    });

    function updateCounts() {
        deckIndicator.textContent = `Deck: ${workingDeck.length}`;
        discardIndicator.textContent = `Discard: ${discardPile.length}`;
    }

    function removeCardElement(card: Card) {
        cardElements[card.id]?.remove();
        delete cardElements[card.id];
    }

    function removeCard(card: Card) {
        const deckIndex = workingDeck.indexOf(card);
        if (deckIndex !== -1) {
            workingDeck.splice(deckIndex, 1);
        }

        const discardIndex = discardPile.indexOf(card);
        if (discardIndex !== -1) {
            discardPile.splice(discardIndex, 1);
        }

        delete hand[card.id];
    }

    function moveCardToDeck(card: Card) {
        removeCardElement(card);
        workingDeck.push(card);

        const cardElement = deckContainer.appendChild(createDiv("card"));
        cardElements[card.id] = cardElement;
        cardElement.appendChild(createDiv("text", card.text));
        cardElement.appendChild(createButton(null, "To Discard", async () => {
            removeCard(card);
            moveCardToDiscard(card);
        }));
        cardElement.appendChild(createButton(null, "To Hand", async () => {
            removeCard(card);
            moveCardToHand(card);
        }));

        updateCounts();
    }

    function moveCardToDiscard(card: Card) {
        removeCardElement(card);
        discardPile.push(card);

        const cardElement = discardContainer.appendChild(createDiv("card"));
        cardElements[card.id] = cardElement;
        cardElement.appendChild(createDiv("text", card.text));
        cardElement.appendChild(createButton(null, "To Hand", async () => {
            removeCard(card);
            moveCardToHand(card);
        }));
        cardElement.appendChild(createButton(null, "To Deck", async () => {
            removeCard(card);
            moveCardToDeck(card);
        }));

        updateCounts();
    }

    function moveCardToHand(card: Card) {
        removeCardElement(card);
        hand[card.id] = card;

        const cardElement = handContainer.appendChild(createDiv("card"));
        cardElements[card.id] = cardElement;
        cardElement.appendChild(createDiv("text", card.text));
        cardElement.appendChild(createButton(null, "Discard", async () => {
            delete hand[card.id];
            moveCardToDiscard(card);
        }));
        cardElement.appendChild(createButton(null, "To Deck", async () => {
            delete hand[card.id];
            moveCardToDeck(card);
        }));

        updateCounts();
    }

    buttonRow.appendChild(createButton(null, "Draw Card", async () => {
        if (workingDeck.length == 0) {
            if (discardPile.length == 0) {
                return;
            }
            PCG.shuffle(discardPile);
            while (discardPile.length > 0) {
                moveCardToDeck(discardPile.pop());
            }
        }
        moveCardToHand(workingDeck.pop());
    }));

    buttonRow.appendChild(createButton(null, "Shuffle Deck", async () => {
        const tempDeck = [];
        while (workingDeck.length > 0) {
            tempDeck.push(workingDeck.pop());
        }
        PCG.shuffle(tempDeck);
        for (const card of tempDeck) {
            moveCardToDeck(card);
        }
    }));

    buttonRow.appendChild(createButton(null, "Go Back", async () => {
        Scenes.setScene(mainMenuScene);
    }));

    const startingCards = Array.from(Object.values(deck.cards));
    PCG.shuffle(startingCards);
    for (const card of startingCards) {
        moveCardToDeck(card);
    }
}


window.addEventListener("load", async () => {
    const sceneContainer = document.body.appendChild(document.createElement("div"));
    sceneContainer.id = "scene";

    Scenes.setScene(mainMenuScene);
    Scenes.run(sceneContainer, true);
});
